import { Common } from './common';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  streamFile(segmentId: string) {
    return this.common.constructPath(`/segments/${segmentId}/file`);
  }
}
